import React, { useEffect, useRef } from 'react';
import { FaInfoCircle } from 'react-icons/fa';
import Select from 'react-select';

const CustomSelect = ({ label, field = '', id, value = '', catalog = [], onChange = () => '', required = true, containBlank = false,info = '', ...rest }) => {
  
    const customStyles = {
        option: (provided, state) => {
            return {
                ...provided,
                fontSize: '13px',
                padding: '4px 12px'
            }
        },
        indicatorSeparator: (provided, state) => {},
        indicatorsContainer: (provided, state) => {
            // console.log(provided);
            // console.log(state);
            return {
                ...provided,
                height: 27,
                padding:0
            }
        },
        control: (provided, state) => {
            return {
                ...provided,
                minHeight: 20,
                borderRadius: 1,
                height: 27,
                fontSize: '13px',
                backgroundColor: '#f7f7f7'
            }
        }
    }

    const sinAsignar = [{ value: '', text: 'Seleccione' }];

    const changeHandler = (e) => {
       // debugger;
        let event = { target: {} };
        event.target.value = e.value;
        event.target.name = field;
        if (e.value)
            onChange(event);
    }

    return (
        <div className="cdsg-input mt-15">
            <label htmlFor={id}>{label}
                {
                    info != '' && <FaInfoCircle color="#E1E1E1" data-tip={info} />
                }
            </label>
            <Select 
            className='customselect'
                name={field}
                options={containBlank ? [...sinAsignar, ...catalog] : catalog}
               
                getOptionLabel={(x) => x.text}
                getOptionValue={(x)=>x.value}
                
                value={catalog.find(x=>x.value==value)!=null?catalog.find(x=>x.value==value):null}
                styles={customStyles} placeholder="Seleccione" onChange={changeHandler} required={required}></Select>
        </div>
    );
}

export default CustomSelect;
